import React from "react";
import Page from "../../ui/page";

export default () => {
  return (
    <Page headerProps={{ icon: "fas fa-plug", title: "API" }}>
      <p>Em breve você encontrará toda a documentação da nossa API</p>
    </Page>
  );
};
